import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import Modal from "../common/Modal";
import Switch from "../common/Switch";
import { setSubPromoterCanManageQR } from "../../services/eventDetailService";
import { color } from "../../styles/theme";

/**
 * QA improvement: promoter-controlled "can this Sub-Promoter create/manage
 * the event QR" permission (EventSubPromoter.CanManageQR) — true by default
 * at creation, previously not exposed anywhere in the Panel. Mirrors
 * EditPermissionsModal.jsx's single-switch-row style since this is one
 * boolean, not a multi-field permission set.
 *
 * @param target { id, name, chatRoomId, canManageQR }
 */
const SubPromoterQrPermissionModal = ({ target, onClose, onUpdated }) => {
  const { t } = useTranslation(["eventDetails", "common"]);
  const [value, setValue] = useState(Boolean(target?.canManageQR));
  const [saving, setSaving] = useState(false);

  if (!target) return null;

  const hasChanges = value !== Boolean(target.canManageQR);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await setSubPromoterCanManageQR(target.chatRoomId, target.id, value);
      toast.success(res.data?.Message || t("subPromoterQrPermissionModal.updateSuccess"));
      onUpdated();
    } catch (err) {
      toast.error(err.response?.data?.Message || t("subPromoterQrPermissionModal.updateError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={t("subPromoterQrPermissionModal.title")}
      subtitle={target.name}
      onClose={onClose}
      busy={saving}
      maxWidth={400}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>{t("common:actions.cancel")}</Button>
          <Button onClick={handleSave} disabled={saving || !hasChanges}>{saving ? t("subPromoterQrPermissionModal.saving") : t("common:actions.save")}</Button>
        </>
      }
    >
      <div style={s.row}>
        <span style={s.label}>{t("subPromoterQrPermissionModal.fieldLabel")}</span>
        <Switch checked={value} onChange={() => setValue((v) => !v)} disabled={saving} />
      </div>
      <p style={s.hint}>
        {value ? t("subPromoterQrPermissionModal.enabledHint") : t("subPromoterQrPermissionModal.disabledHint")}
      </p>
    </Modal>
  );
};

const s = {
  row: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 2px" },
  label: { fontSize: 13.5, color: color.gray800, fontWeight: 500 },
  hint: { margin: "10px 2px 0", fontSize: 12, color: color.textMuted, lineHeight: 1.5 },
};

export default SubPromoterQrPermissionModal;
